export interface UserRef {
  id: string;
  name: string;
  email?: string;
  userNumber?: number | null;
}

export function userRef(id: string | null | undefined, name?: string | null): UserRef | null {
  return id ? { id, name: name ?? "" } : null;
}

export function nameRef(name: string | null | undefined): UserRef | null {
  return name ? { id: "", name } : null;
}

export function toUserRef(a: unknown): UserRef {
  if (typeof a === "string") return { id: "", name: a };
  const o = (a ?? {}) as Record<string, unknown>;
  return {
    id: (o.id as string) ?? "",
    name: (o.name as string) ?? "",
    email: (o.email as string) || undefined,
    userNumber: (o.userNumber as number) ?? null,
  };
}
